import { Doughnut } from 'react-chartjs-2'
import { CHART_COLOURS } from './SimpleLineChart'

export default function SimpleDoughnutChart ({ labels, datasets }) {
  datasets.forEach((dataset, i) => {
    dataset.backgroundColor = dataset.data.map((_, j) => CHART_COLOURS[j % CHART_COLOURS.length])
    dataset.borderColor = dataset.backgroundColor
    dataset.borderWidth = 1
  })
  return (
    <Doughnut
      data={{
        labels,
        datasets
      }}
    />
  )
}
